<template>
  <v-app id="uso-cientifico" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Título ou tipo"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="index"
          show-expand
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items">
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} registros</span
            >
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>

          <template v-slot:item.titulo="{ item }">
            <a
              v-if="item.link != ''"
              :href="item.link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.titulo }}
            </a>
            <span v-else>
              {{ item.titulo }}
            </span>
          </template>

          <template v-slot:item.local="{ item }">
            <a
              v-if="item.url_local && item.url_local !== ''"
              :href="item.url_local"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.local }}
            </a>
            <span v-else>
              {{ item.local }}
            </span>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="7">
              <div class="table-interna">
                <div class="dropdown-article">
                  <strong>Resumo:</strong>
                  <p
                    class="resumo-text"
                    :class="{ expanded: expandedItems[item.id] }"
                  >
                    {{
                      expandedItems[item.id]
                        ? item.resumo
                        : item.resumo.substring(0, 250) +
                          (item.resumo.length > 250 ? '...' : '')
                    }}
                    <span
                      v-if="item.resumo.length > 150"
                      @click="toggleExpand(item.id)"
                      class="c-expand"
                    >
                      {{
                        expandedItems[item.id]
                          ? 'Mostrar menos.'
                          : 'Mostrar mais.'
                      }}
                    </span>
                  </p>
                </div>
                <div class="dropdown-article">
                  <strong>DOI:</strong>
                  <p>{{ item.doi }}</p>
                </div>
                <!-- <div class="dropdown-article">
                  <strong>Pdf:</strong>
                  <p>
                    <a
                      :href="item.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ item.url }}</a
                    >
                  </p>
                </div> -->
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'Tabela',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      expandedItems: {},
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Tipo',
          align: 'start',
          filterable: true,
          value: 'tipo',
          sortable: false,
        },
        {
          text: 'Titulo',
          align: 'start',
          filterable: true,
          value: 'titulo',
          sortable: false,
        },
        {
          text: 'Autor principal',
          align: 'start',
          filterable: false,
          value: 'autor',
          sortable: false,
        },
        {
          text: 'Local',
          align: 'start',
          filterable: false,
          value: 'local',
          sortable: false,
        },
        {
          text: 'Ano',
          align: 'start',
          filterable: false,
          value: 'ano',
          sortable: true,
        },

        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    toggleExpand(itemId) {
      this.$set(this.expandedItems, itemId, !this.expandedItems[itemId])
    },
  },
}
</script>

<style lang="scss">
#uso-cientifico .table-interna {
  margin: 15px 0;
}

#uso-cientifico .dropdown-article {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  gap: 10px;

  p {
    margin: 0;
  }
}

#uso-cientifico .resumo-text {
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

#uso-cientifico .c-expand {
  color: #0d98bb;
  cursor: pointer;
}
</style>
